// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

.background-color-resetpass {
  font-family: "Montserrat", sans-serif;
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
}
.background-color-resetpass #wrapFogot #logo {
  width: 100%;
  text-align: center;
  margin-bottom: 25px;
}
.background-color-resetpass #wrapFogot #logo .logo-name {
  font-style: normal;
  font-weight: bold;
  font-size: 25px;
  line-height: 27px;
  text-transform: uppercase;
  color: #121b2b;
}
.background-color-resetpass #wrapFogot #logo .logo-name .pool-color {
  color: #1ba192;
}
.background-color-resetpass #wrapFogot #fogotForm form {
  width: 364px !important;
  min-height: 218px;
  left: 778px;
  top: 347px;
  background: #ffffff;
  box-shadow: 0px -1px 10px rgba(170, 170, 170, 0.15), 0px 8px 15px rgba(224, 224, 224, 0.35);
  border-radius: 15px;
}
.background-color-resetpass #wrapFogot #fogotForm .form-size {
  padding: 25px 15px 5px 15px;
  width: 100%;
  height: 100%;
}
.background-color-resetpass #wrapFogot #fogotForm .form-size .email-title {
  margin-bottom: 10px;
}
.background-color-resetpass #wrapFogot #fogotForm .form-size .email-title .control-label {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  display: inline-block;
}
.background-color-resetpass #wrapFogot #fogotForm .form-size .email-title .form-control {
  background: #ffffff;
  border: 1px solid #d5d5d5;
  box-sizing: border-box;
  border-radius: 5px;
  height: 50px;
}
.background-color-resetpass #wrapFogot #fogotForm .form-size .size-col .button-change {
  width: 100%;
  height: 49px;
  border-radius: 5px;
  background: #66b6ab;
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 17px;
  text-align: center;
  color: #ffffff;
}
.background-color-resetpass #wrapFogot #fogotForm .alert-error-login {
  width: 100%;
}
.background-color-resetpass .back-log {
  height: 17px;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 17px;
  text-align: center;
  color: #666666;
  width: 100%;
  margin-top: 30px;
}
.background-color-resetpass .back-log .forgot-title {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #666666;
}
.background-color-resetpass .back-log .forgot-title:hover {
  text-decoration: none;
}

.password-toggle-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.54);
}`, "",{"version":3,"sources":["webpack://./src/app/main/reset-password/reset-password.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;;AAEA;EACE,qCAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACI;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;AACN;AAAM;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;AAER;AADQ;EACE,cAAA;AAGV;AAGM;EACE,uBAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,2FAAA;EAEA,mBAAA;AAFR;AAIM;EACE,2BAAA;EACA,WAAA;EACA,YAAA;AAFR;AAGQ;EACE,mBAAA;AADV;AAEU;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AAAZ;AAEU;EACE,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;AAAZ;AAKU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAHZ;AAQM;EACE,WAAA;AANR;AAUE;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;AARJ;AAUI;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AARN;AASM;EACE,qBAAA;AAPR;;AAaA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA;AAVF","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\n.background-color-resetpass {\n  font-family: \"Montserrat\", sans-serif;\n  display: flex;\n  height: 100vh;\n  align-items: center;\n  justify-content: center;\n  #wrapFogot {\n    #logo {\n      width: 100%;\n      text-align: center;\n      margin-bottom: 25px;\n      .logo-name {\n        font-style: normal;\n        font-weight: bold;\n        font-size: 25px;\n        line-height: 27px;\n        text-transform: uppercase;\n        color: #121b2b;\n        .pool-color {\n          color: #1ba192;\n        }\n      }\n    }\n\n    #fogotForm {\n      form {\n        width: 364px !important;\n        min-height: 218px;\n        left: 778px;\n        top: 347px;\n        background: #ffffff;\n        box-shadow: 0px -1px 10px rgba(170, 170, 170, 0.15),\n          0px 8px 15px rgba(224, 224, 224, 0.35);\n        border-radius: 15px;\n      }\n      .form-size {\n        padding: 25px 15px 5px 15px;\n        width: 100%;\n        height: 100%;\n        .email-title {\n          margin-bottom: 10px;\n          .control-label {\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 15px;\n            color: #333333;\n            display: inline-block;\n          }\n          .form-control {\n            background: #ffffff;\n            border: 1px solid #d5d5d5;\n            box-sizing: border-box;\n            border-radius: 5px;\n            height: 50px;\n          }\n        }\n\n        .size-col {\n          .button-change {\n            width: 100%;\n            height: 49px;\n            border-radius: 5px;\n            background: #66b6ab;\n            cursor: pointer;\n            font-style: normal;\n            font-weight: normal;\n            font-size: 16px;\n            line-height: 17px;\n            text-align: center;\n            color: #ffffff;\n          }\n        }\n      }\n\n      .alert-error-login {\n        width: 100%;\n      }\n    }\n  }\n  .back-log {\n    height: 17px;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 17px;\n    text-align: center;\n    color: #666666;\n    width: 100%;\n    margin-top: 30px;\n\n    .forgot-title {\n      font-style: normal;\n      font-weight: normal;\n      font-size: 16px;\n      line-height: 20px;\n      text-align: center;\n      color: #666666;\n      &:hover {\n        text-decoration: none;\n      }\n    }\n  }\n}\n\n.password-toggle-icon {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: rgba(0, 0, 0, 0.54);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
